module.exports = __webpack_public_path__ + "media/images/flutter-white-b5a65713701016e62216f745cccf8266.png";